import { render } from "./CustomerTestimonial.vue?vue&type=template&id=22b2d899"
import script from "./CustomerTestimonial.vue?vue&type=script&lang=js"
export * from "./CustomerTestimonial.vue?vue&type=script&lang=js"

import "./CustomerTestimonial.vue?vue&type=style&index=0&id=22b2d899&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__